// extracted by mini-css-extract-plugin
export default {"news":"new_news__ujrMb","news__cards":"new_news__cards__siRfh"};